/* ==========================================================================
   Computer Bazar Landing Page Interactions & Theme Script
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  // 1. Product Image Gallery Switcher
  const mainImg = document.getElementById('cb-main-product-image');
  const thumbs = document.querySelectorAll('.cb-thumb-item');

  if (mainImg && thumbs.length > 0) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(t => t.classList.remove('active'));
        this.classList.add('active');
        const newSrc = this.getAttribute('data-img-src');
        if (newSrc) {
          mainImg.setAttribute('src', newSrc);
        }
      });
    });
  }

  // 2. Quantity Stepper
  const qtyDec = document.getElementById('cb-qty-dec');
  const qtyInc = document.getElementById('cb-qty-inc');
  const qtyVal = document.getElementById('cb-qty-val');
  const qtyInput = document.getElementById('cb-quantity-input');

  let currentQty = 1;

  if (qtyDec && qtyInc && qtyVal) {
    qtyDec.addEventListener('click', function (e) {
      e.preventDefault();
      if (currentQty > 1) {
        currentQty--;
        qtyVal.textContent = currentQty;
        if (qtyInput) qtyInput.value = currentQty;
      }
    });

    qtyInc.addEventListener('click', function (e) {
      e.preventDefault();
      currentQty++;
      qtyVal.textContent = currentQty;
      if (qtyInput) qtyInput.value = currentQty;
    });
  }

  // 3. Buy It Now (Fast Checkout Action)
  const buyBtn = document.getElementById('cb-buy-now-btn');
  if (buyBtn) {
    buyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      const variantId = buyBtn.getAttribute('data-variant-id');
      const checkoutUrl = buyBtn.getAttribute('data-custom-checkout') || '/checkout';

      if (variantId && variantId !== '0') {
        buyBtn.textContent = 'Processing...';
        buyBtn.disabled = true;

        // Clear cart first so previous test clicks do not accumulate quantity
        fetch('/cart/clear.js', { method: 'POST' })
          .then(() => {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                items: [{
                  id: parseInt(variantId, 10),
                  quantity: currentQty
                }]
              })
            });
          })
          .then(res => res.json())
          .then(() => {
            window.location.href = '/checkout';
          })
          .catch(() => {
            window.location.href = checkoutUrl;
          });
      } else {
        // Fallback or external checkout redirect
        window.location.href = checkoutUrl;
      }
    });
  }

  // 4. Video Hero Modal Player
  const videoHero = document.getElementById('cb-video-hero-trigger');
  const videoModal = document.getElementById('cb-video-modal');
  const videoClose = document.getElementById('cb-modal-close-btn');
  const modalIframe = document.getElementById('cb-modal-iframe');
  const modalVideo = document.getElementById('cb-modal-video');

  if (videoHero && videoModal && videoClose) {
    const hostedUrl = videoHero.getAttribute('data-video-hosted');
    const directUrl = videoHero.getAttribute('data-video-direct');
    const videoUrl = videoHero.getAttribute('data-video-url');

    function closePlayer() {
      if (modalIframe) {
        modalIframe.setAttribute('src', '');
        modalIframe.style.display = 'none';
      }
      if (modalVideo) {
        modalVideo.pause();
        modalVideo.removeAttribute('src');
        modalVideo.load();
        modalVideo.style.display = 'none';
      }
      videoModal.classList.remove('open');
    }

    videoHero.addEventListener('click', function () {
      const mp4Url = hostedUrl || directUrl;
      if (mp4Url) {
        if (modalIframe) {
          modalIframe.style.display = 'none';
          modalIframe.setAttribute('src', '');
        }
        if (modalVideo) {
          modalVideo.style.display = 'block';
          modalVideo.setAttribute('src', mp4Url);
          modalVideo.play();
        }
      } else if (videoUrl) {
        if (modalVideo) {
          modalVideo.pause();
          modalVideo.style.display = 'none';
          modalVideo.removeAttribute('src');
        }
        if (modalIframe) {
          modalIframe.style.display = 'block';
          let embedUrl = videoUrl;
          if (videoUrl.includes('youtube.com/watch?v=')) {
            const id = videoUrl.split('v=')[1].split('&')[0];
            embedUrl = `https://www.youtube.com/embed/${id}?autoplay=1`;
          } else if (videoUrl.includes('youtu.be/')) {
            const id = videoUrl.split('youtu.be/')[1].split('?')[0];
            embedUrl = `https://www.youtube.com/embed/${id}?autoplay=1`;
          }
          modalIframe.setAttribute('src', embedUrl);
        }
      }
      videoModal.classList.add('open');
    });

    videoClose.addEventListener('click', closePlayer);

    videoModal.addEventListener('click', function (e) {
      if (e.target === videoModal) {
        closePlayer();
      }
    });
  }

  // 5. Checkout Action for Ticker CTA Button
  const tickerBtn = document.getElementById('cb-ticker-scroll-btn');
  if (tickerBtn) {
    tickerBtn.addEventListener('click', function (e) {
      e.preventDefault();
      const buyBtn = document.getElementById('cb-buy-now-btn');
      if (buyBtn) {
        tickerBtn.style.opacity = '0.7';
        tickerBtn.style.pointerEvents = 'none';
        tickerBtn.textContent = 'Redirecting to Checkout...';
        buyBtn.click();
      } else {
        const link = tickerBtn.getAttribute('href') || '/checkout';
        window.location.href = link;
      }
    });
  }

  // 6. Direct Checkout Action for Red Booking Alert Banner
  const alertCalloutBtn = document.getElementById('cb-alert-callout-btn');
  if (alertCalloutBtn) {
    alertCalloutBtn.addEventListener('click', function (e) {
      e.preventDefault();
      const buyBtn = document.getElementById('cb-buy-now-btn');
      if (buyBtn) {
        alertCalloutBtn.style.opacity = '0.7';
        alertCalloutBtn.style.pointerEvents = 'none';
        alertCalloutBtn.textContent = 'Redirecting to Checkout...';
        buyBtn.click();
      } else {
        window.location.href = '/checkout';
      }
    });
  }
});
